/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* eslint-disable */
import type { microsoft_graph_user } from '../models/microsoft_graph_user'
import type { microsoft_graph_userCollectionResponse } from '../models/microsoft_graph_userCollectionResponse'
import type { ODataCountResponse } from '../models/ODataCountResponse'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class UsersUserService {
  /**
   * List users
   * List properties and relationships of the user objects.
   * @returns microsoft_graph_userCollectionResponse Retrieved collection
   * @throws ApiError
   */
  public static userListUser({
    consistencyLevel,
    top,
    search,
    filter,
    count,
    orderby,
    select,
    expand,
  }: {
    /**
     * Indicates the requested consistency level. Documentation URL: https://docs.microsoft.com/graph/aad-advanced-queries
     */
    consistencyLevel?: string
    /**
     * Show only the first n items
     */
    top?: number
    /**
     * Search items by search phrases
     */
    search?: string
    /**
     * Filter items by property values
     */
    filter?: string
    /**
     * Include count of items
     */
    count?: boolean
    /**
     * Order items by property values
     */
    orderby?: Array<string>
    /**
     * Select properties to be returned
     */
    select?: Array<string>
    /**
     * Expand related entities
     */
    expand?: Array<string>
  }): CancelablePromise<microsoft_graph_userCollectionResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users',
      headers: {
        ConsistencyLevel: consistencyLevel,
      },
      query: {
        $top: top,
        $search: search,
        $filter: filter,
        $count: count,
        $orderby: orderby,
        $select: select,
        $expand: expand,
      },
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Create user
   * Create a new user object.
   * @returns microsoft_graph_user Created entity
   * @throws ApiError
   */
  public static userCreateUser({
    requestBody,
  }: {
    /**
     * New entity
     */
    requestBody: microsoft_graph_user
  }): CancelablePromise<microsoft_graph_user> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Get a user
   * Retrieve the properties and relationships of user object. This operation returns by default only a subset of the more commonly used properties for each user. These default properties are noted in the Properties section. To get properties that are not returned by default, do a GET operation for the user and specify the properties in a $select OData query option. Because the user resource supports extensions, you can also use the GET operation to get custom properties and extension data in a user instance. Customers through Microsoft Entra ID for customers can also use this API operation to retrieve their details.
   * @returns microsoft_graph_user Retrieved entity
   * @throws ApiError
   */
  public static userGetUser({
    userId,
    select,
    expand,
  }: {
    /**
     * The unique identifier of user
     */
    userId: string
    /**
     * Select properties to be returned
     */
    select?: Array<string>
    /**
     * Expand related entities
     */
    expand?: Array<string>
  }): CancelablePromise<microsoft_graph_user> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{user-id}',
      path: {
        'user-id': userId,
      },
      query: {
        $select: select,
        $expand: expand,
      },
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Update user
   * Update the properties of a user object.
   * @returns microsoft_graph_user Success
   * @throws ApiError
   */
  public static userUpdateUser({
    userId,
    requestBody,
  }: {
    /**
     * The unique identifier of user
     */
    userId: string
    /**
     * New property values
     */
    requestBody: microsoft_graph_user
  }): CancelablePromise<microsoft_graph_user> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/users/{user-id}',
      path: {
        'user-id': userId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Delete user
   * Deletes a user.
   * @returns any Success
   * @throws ApiError
   */
  public static userDeleteUser({
    userId,
    ifMatch,
  }: {
    /**
     * The unique identifier of user
     */
    userId: string
    /**
     * ETag
     */
    ifMatch?: string
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{user-id}',
      path: {
        'user-id': userId,
      },
      headers: {
        'If-Match': ifMatch,
      },
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Get a user
   * Retrieve the properties and relationships of user object. This operation returns by default only a subset of the more commonly used properties for each user. These default properties are noted in the Properties section. To get properties that are not returned by default, do a GET operation for the user and specify the properties in a $select OData query option. Because the user resource supports extensions, you can also use the GET operation to get custom properties and extension data in a user instance. Customers through Microsoft Entra ID for customers can also use this API operation to retrieve their details.
   * @returns microsoft_graph_user Retrieved entity
   * @throws ApiError
   */
  public static userGetUserGraphBPreUserPrincipalName({
    userPrincipalName,
    select,
    expand,
  }: {
    /**
     * Alternate key of user
     */
    userPrincipalName: string | null
    /**
     * Select properties to be returned
     */
    select?: Array<string>
    /**
     * Expand related entities
     */
    expand?: Array<string>
  }): CancelablePromise<microsoft_graph_user> {
    return __request(OpenAPI, {
      method: 'GET',
      url: "/users(userPrincipalName='{userPrincipalName}')",
      path: {
        userPrincipalName: userPrincipalName,
      },
      query: {
        $select: select,
        $expand: expand,
      },
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Update user
   * Update the properties of a user object.
   * @returns microsoft_graph_user Success
   * @throws ApiError
   */
  public static userUpdateUserGraphBPreUserPrincipalName({
    userPrincipalName,
    requestBody,
  }: {
    /**
     * Alternate key of user
     */
    userPrincipalName: string | null
    /**
     * New property values
     */
    requestBody: microsoft_graph_user
  }): CancelablePromise<microsoft_graph_user> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: "/users(userPrincipalName='{userPrincipalName}')",
      path: {
        userPrincipalName: userPrincipalName,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Delete user
   * Deletes a user.
   * @returns any Success
   * @throws ApiError
   */
  public static userDeleteUserGraphBPreUserPrincipalName({
    userPrincipalName,
    ifMatch,
  }: {
    /**
     * Alternate key of user
     */
    userPrincipalName: string | null
    /**
     * ETag
     */
    ifMatch?: string
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: "/users(userPrincipalName='{userPrincipalName}')",
      path: {
        userPrincipalName: userPrincipalName,
      },
      headers: {
        'If-Match': ifMatch,
      },
      errors: {
        400: `error`,
      },
    })
  }
  /**
   * Get the number of the resource
   * @returns ODataCountResponse The count of the resource
   * @throws ApiError
   */
  public static userGetCount({
    consistencyLevel,
    search,
    filter,
  }: {
    /**
     * Indicates the requested consistency level. Documentation URL: https://docs.microsoft.com/graph/aad-advanced-queries
     */
    consistencyLevel?: string
    /**
     * Search items by search phrases
     */
    search?: string
    /**
     * Filter items by property values
     */
    filter?: string
  }): CancelablePromise<ODataCountResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/$count',
      headers: {
        ConsistencyLevel: consistencyLevel,
      },
      query: {
        $search: search,
        $filter: filter,
      },
      errors: {
        400: `error`,
      },
    })
  }
}
